import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FiFileText, FiPhone, FiMessageCircle, FiSearch } from "react-icons/fi";
import ProductCard from "./ProductCard";
import { findProduct, toImages } from "./catalogueData";
import { PHONE, PHONE_LABEL, EMAIL, whatsappLink } from "../../contact";
import "./Catalogue.css";

const PERKS = ["Fabrication sur mesure", "Inox de haute qualité", "Livraison et installation"];

const ProductDetail = () => {
  const { id } = useParams();
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState({ on: false, x: 50, y: 50 });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const found = findProduct(id);

  if (!found) {
    return (
      <div className="cat">
        <div className="cat-notfound">
          <h1>Produit introuvable</h1>
          <Link to="/catalogue" className="cat-btn">
            Retour au catalogue
          </Link>
        </div>
      </div>
    );
  }

  const { sub, product } = found;
  const title = product.titre.trim();
  const images = toImages(product.images);
  const related = (sub.produits || []).filter((p) => p.id !== product.id).slice(0, 4);
  const quoteLink = `/contact?produit=${encodeURIComponent(title)}`;
  const whatsapp = whatsappLink(`Bonjour, je souhaite un devis pour : ${title}`);

  const handleZoomMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setZoom({
      on: true,
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100,
    });
  };

  return (
    <div className="cat cat--detail">
      <div className="cat-detail">
        <nav className="cat-breadcrumb cat-breadcrumb--dark" aria-label="Fil d'Ariane">
          <Link to="/catalogue">Catalogue</Link>
          <span>/</span>
          <Link to={`/catalogue/${sub.idcode}`}>{sub.nom.trim()}</Link>
          <span>/</span>
          <strong>{title}</strong>
        </nav>

        <div className="cat-detail__grid">
          <motion.div
            className="cat-gallery"
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <div
              className="cat-zoom"
              onMouseMove={handleZoomMove}
              onMouseLeave={() => setZoom((z) => ({ ...z, on: false }))}
            >
              <img
                src={images[active]}
                alt={title}
                style={{
                  transformOrigin: `${zoom.x}% ${zoom.y}%`,
                  transform: zoom.on ? "scale(2)" : "scale(1)",
                }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <span className="cat-zoom__hint">
                <FiSearch /> Survolez pour zoomer
              </span>
            </div>
            {images.length > 1 && (
              <div className="cat-thumbs">
                {images.map((src, i) => (
                  <button
                    type="button"
                    key={src}
                    className={`cat-thumb${i === active ? " is-active" : ""}`}
                    onClick={() => setActive(i)}
                    aria-label={`Photo ${i + 1}`}
                  >
                    <img src={src} alt="" onContextMenu={(e) => e.preventDefault()} />
                  </button>
                ))}
              </div>
            )}
          </motion.div>

          <motion.div
            className="cat-info"
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
          >
            <span className="cat-eyebrow cat-eyebrow--dark">{sub.nom.trim()}</span>
            <h1>{title}</h1>
            <p className="cat-info__desc">{product.description}</p>

            <ul className="cat-perks">
              {PERKS.map((perk) => (
                <li key={perk}>{perk}</li>
              ))}
            </ul>

            <div className="cat-actions">
              <Link to={quoteLink} className="cat-btn cat-btn--primary">
                <FiFileText /> Demander un devis
              </Link>
              <a
                href={whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="cat-btn cat-btn--whatsapp"
              >
                <FiMessageCircle /> WhatsApp
              </a>
              <a href={`tel:${PHONE}`} className="cat-btn cat-btn--ghost">
                <FiPhone /> {PHONE_LABEL}
              </a>
            </div>
            <p className="cat-info__mail">
              ou par email : <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            </p>
          </motion.div>
        </div>

        {related.length > 0 && (
          <section className="cat-related">
            <h2>Dans la même catégorie</h2>
            <div className="cat-products">
              {related.map((p, i) => (
                <ProductCard key={p.id} product={p} index={i} />
              ))}
            </div>
          </section>
        )}
      </div>

      <div className="cat-bar">
        <Link to={quoteLink} className="cat-btn cat-btn--primary">
          <FiFileText /> Devis
        </Link>
        <a
          href={whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="cat-btn cat-btn--whatsapp"
        >
          <FiMessageCircle /> WhatsApp
        </a>
        <a href={`tel:${PHONE}`} className="cat-btn cat-btn--ghost" aria-label="Appeler">
          <FiPhone />
        </a>
      </div>
    </div>
  );
};

export default ProductDetail;
